import { useAtomValue } from 'jotai'
import { useState } from 'react'

import { Button, Skeleton, Flex, Grid, Link } from '@sequencehq/core-components'
import { IndigoIndigo60, Primary13SemiBold } from '@sequencehq/core-components'
import { billingScheduleIdAtom } from 'Invoices/atoms/invoiceEditing.atom'
import {
  BillingSchedulePhaseTable,
  useSchedulePricingSection
} from 'BillingScheduleHome/index'
import { ProductPriceDrawer } from 'Products/index'
import { Section } from '../components'

export const Schedule = () => {
  const billingScheduleId = useAtomValue(billingScheduleIdAtom)
  if (!billingScheduleId) return null
  return <ScheduleSection billingScheduleId={billingScheduleId} />
}

const ScheduleSection = ({
  billingScheduleId
}: {
  billingScheduleId: string
}) => {
  const hook = useSchedulePricingSection({ billingScheduleId })
  const [selectedPriceId, setSelectedPriceId] = useState<string | null>(null)

  if (hook.isLoading) {
    return (
      <Section title="Schedule">
        <Skeleton height="200px" width="100%" />
      </Section>
    )
  }

  return (
    <Section title="Schedule" data-testid="invoice.schedule">
      <Flex gap="16px" flexDir="column">
        <Grid gridTemplateRows="auto">
          {hook.phases?.map(phase => (
            <BillingSchedulePhaseTable
              key={phase.id}
              phase={phase}
              mountExpanded={hook.initialPhaseToExpand === phase.id}
              interactive={true}
              variant="compact"
              onSelectPrice={setSelectedPriceId}
            />
          ))}
        </Grid>

        {selectedPriceId && (
          <ProductPriceDrawer
            priceId={selectedPriceId}
            onClose={() => setSelectedPriceId(null)}
            showBillingScheduleInfo={false}
          />
        )}

        <Button
          variant="unstyled"
          data-testid="invoice.schedule.view-schedule"
          as={Link.Unstyled}
          to={`/billing-schedules/${billingScheduleId}`}
          style={{
            ...Primary13SemiBold,
            width: 'fit-content',
            height: 'fit-content',
            padding: '0',
            color: IndigoIndigo60
          }}
        >
          View schedule
        </Button>
      </Flex>
    </Section>
  )
}
